import { API_STATUS } from '@/constants';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchCategories = createAsyncThunk(
  'categories/fetchCategories',
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(`/api/categories`);
      if (!response.ok) {
        throw new Error('Failed to fetch categories');
      }
      const { data, status } = await response.json();

      if (status !== API_STATUS.SUCCESS) {
        throw new Error('Failed to fetch categories');
      }
      return data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

export const fetchBrands = createAsyncThunk(
  'categories/fetchBrands',
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(`/api/brands`);
      if (!response.ok) {
        throw new Error('Failed to fetch brand');
      }
      const { data, status } = await response.json();

      if (status !== API_STATUS.SUCCESS) {
        throw new Error('Failed to fetch brand');
      }
      return data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);
